import { post, get } from '../../../../services/request';

// Get All Matrix Service Request
export const GetAllMatrixServiceRequest = (payload) => {
    return post(
        "SiteOnboardingPlanner/GetAllRequestedSites",
        payload
    );
};

// Get All Site Onboarding Planner dropdown lists
export const GetAllsiteonboardingplannerlists = () => {
    return get("SiteOnboardingPlanner/GetAllDropDownsList");
};

// Get Worklist by RPCE Id
export const GetWorklistByRPCEId = (rpceID) => {
    return post((`Common/GetWorkListByRPCEIds?rpceIds=${rpceID}`));
}

// Get Practice Name by Worklist ID
export const GetPracticeNameByWorkListId = (worklistID) => {
    return get((`Common/GetPracticesByWorklistIds?worklistIds=${worklistID}`));
}

// Exporting Matrix Service Request Data
export const ExportMatrixServiceRequest = (payload) => {
    return post("SiteOnboardingPlanner/SiteOnboardingExportToCSV", payload);
};

//Add new service request
export const AddNewMatrixServiceRequest = (payload) => {
    return post("SiteOnboardingPlanner/SaveNewRequestSiteDetail", payload);
}

// Bulk Save Service Requests
export const BulksaveMatrixServiceRequest = (data) => {
    return post('SiteOnboardingPlanner/SiteOnBoardingPlannerBulkUpdate', data);
}

// Delete Service Request
export const DeleteMatrixServiceRequest = (id, modifiedBy) => {
    return post(`SiteOnboardingPlanner/DeleteSiteRequest`, {
        SiteOnboardingID: id,
        ModifiedBy: modifiedBy
    });
}

// Get All Onboarding Site Demand Planner
export const GetAllOnboardingSiteDemandPlanner = () => {
    return get('SiteOnboardingPlanner/GetAllRequestedSitesYearlyDemands');
}

// Get All Onboarding Site Demand Planner Legend List
export const GetAllOnboardingSiteDemandPlannerLegendList = () => {
    return get('SiteOnboardingPlanner/GetOnboardingSiteDemandPlannerLegend');
}

// Update Onboarding Site Demand Planner Data
export const UpdateOnboardingSiteDemandPlannerData = (data) => {
    return post('SiteOnboardingPlanner/SiteOnBoardingYearlyDemandPlannerBulkInsertUpdate', data);
}
